import { render, staticRenderFns } from "./ticketDetail.vue?vue&type=template&id=ec0937fc&scoped=true&"
import script from "./ticketDetail.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ticketDetail.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./ticketDetail.vue?vue&type=style&index=0&id=ec0937fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0937fc",
  null
  
)

export default component.exports